export class InputManager {
    constructor() {
        this.keys = new Map();
        this.mouse = {
            x: 0,
            y: 0,
            isDown: false
        };
    }

    init() {
        window.addEventListener('keydown', (e) => this.onKeyDown(e));
        window.addEventListener('keyup', (e) => this.onKeyUp(e));
        window.addEventListener('mousemove', (e) => this.onMouseMove(e));
        window.addEventListener('mousedown', () => this.onMouseDown());
        window.addEventListener('mouseup', () => this.onMouseUp());
    }

    onKeyDown(event) {
        this.keys.set(event.code, true);
    }

    onKeyUp(event) {
        this.keys.set(event.code, false);
    }

    onMouseMove(event) {
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }

    onMouseDown() {
        this.mouse.isDown = true;
    }

    onMouseUp() {
        this.mouse.isDown = false;
    }

    isKeyPressed(keyCode) {
        return this.keys.get(keyCode) || false;
    }
}
